import React, { useState } from 'react';
import { IoArrowForward } from 'react-icons/io5';
import './whatsapp_button.css';

const WhatsAppButton = () => {
    const [isHovered, setIsHovered] = useState(false);
    const number = process.env.REACT_APP_WHATSAPP_NUMBER;
    const message = process.env.REACT_APP_WHATSAPP_MESSAGE;
    const whatsappUrl = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`whatsapp-button visible ${isHovered ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <span className="whatsapp-text">WhatsApp</span>
            <div className="arrow-icon">
                <IoArrowForward />
            </div>
        </a>
    );
};

export default WhatsAppButton;
